import { summarizeSCBalances } from '@/libs/summarizeSCBalances';
import { Currency } from '@/queries/types/Currency.types';

export type GameLaunchBalanceGateAction = 'launch' | 'deposit' | 'promo-disallowed';

type GetGameLaunchBalanceGateActionParams = {
  currency: string;
  goldCoin?: number | null;
  sweepCoin?: number | null;
  bonusSweepCoin?: number | null;
  isBonusAllowed?: boolean;
};

type ShouldShowRestrictedGamePromoOnlyPopupParams = Omit<GetGameLaunchBalanceGateActionParams, 'goldCoin'> & {
  isGameSessionActive: boolean;
};

export function getGameLaunchBalanceGateAction({
  currency,
  goldCoin,
  sweepCoin,
  bonusSweepCoin,
  isBonusAllowed = true,
}: GetGameLaunchBalanceGateActionParams): GameLaunchBalanceGateAction {
  if (currency === Currency.GC) {
    return Number(goldCoin) > 0 ? 'launch' : 'deposit';
  }

  const regularSweepCoin = Number(sweepCoin);
  const promoSweepCoin = Number(bonusSweepCoin);

  if (isBonusAllowed) {
    return summarizeSCBalances(regularSweepCoin, promoSweepCoin) > 0 ? 'launch' : 'deposit';
  }

  if (regularSweepCoin > 0) {
    return 'launch';
  }

  if (promoSweepCoin > 0) {
    return 'promo-disallowed';
  }

  return 'deposit';
}

export function shouldShowRestrictedGamePromoOnlyPopup({
  isGameSessionActive,
  currency,
  sweepCoin,
  bonusSweepCoin,
  isBonusAllowed,
}: ShouldShowRestrictedGamePromoOnlyPopupParams) {
  return isGameSessionActive
    && getGameLaunchBalanceGateAction({
      currency,
      sweepCoin,
      bonusSweepCoin,
      isBonusAllowed,
    }) === 'promo-disallowed';
}
